import React from 'react'

export const Footer: React.FC = () => {
  return (
    <footer className="w-full bg-[#faf9f5] flex items-center justify-between px-6 py-3 shrink-0 border-t border-[#e0d4be] font-aurilearn">
      <p style={{ fontSize: 13, color: '#7a6020', lineHeight: '16px', fontWeight: 400 }}>
        © 2026 Aurilearn Learning Management System. All rights reserved.
      </p>
      <div style={{ display: 'flex', gap: 16 }}>
        <a href="#" style={{ fontSize: 13, color: '#7a6020', lineHeight: '16px', fontWeight: 400 }}>
          System Status
        </a>
        <a href="#" style={{ fontSize: 13, color: '#7a6020', lineHeight: '16px', fontWeight: 400 }}>
          Documentation
        </a>
        <a href="#" style={{ fontSize: 13, color: '#7a6020', lineHeight: '16px', fontWeight: 400 }}>
          Privacy Policy
        </a>
        <a href="#" style={{ fontSize: 13, color: '#7a6020', lineHeight: '16px', fontWeight: 400 }}>
          Contact Support
        </a>
      </div>
    </footer>
  )
}
